import { NextPage } from "next";
import SimulatorSection from "components/corphurusato/SimulatorSection";
import { useMemo } from "react";
import Head from "next/head";
import Header from "components/official/header/Header";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";
import Footer from "components/official/footer/Footer";
import Main from "components/corphurusato/parts/Main";
import AboutCorpHurusato from "components/corphurusato/AboutCorpHurusato";
import AboutCorpAnimeHurusato from "components/corphurusato/AboutCorpAnimeHurusato";
import DeductionFlow from "components/corphurusato/DeductionFlow";
import Faq from "components/corphurusato/Faq";
import Background from "components/corphurusato/parts/Background";
import KeyVisual from "components/corphurusato/KeyVisual";
import { LibraryContextProvider } from "lib/context/corphurusato/LibraryContext";

const CorpHurusato: NextPage<FrontAuthProps> = () => {
  const baseUrl = process.env.BASE_URL;
  const robotsValue = useMemo(() => {
    return process.env.APP_ENV === "production" ? "all" : "noindex";
  }, []);
  return (
    <>
      <Head>
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <title>【公式】企業版ふるさと納税とは？｜アニメファンド</title>
        <meta
          name="description"
          content="企業版ふるさと納税は、企業が「応援したい自治体に寄附することで税金の9割控除」が受けられる制度です。"
        />
        <meta name="keywords" content="企業版ふるさと納税,アニメふるさと納税,企業版アニメふるさと納税" />
        <meta property="og:title" content="企業版アニメふるさと納税とは？｜ふるさと納税サイト [アニメファンド]" />
        <meta
          property="og:description"
          content="企業が「応援したい自治体に寄附することで税金の9割控除」が受けられる制度です。自治体を盛り上げるためにアニメに関連する事業に活用されます。"
        />
        <meta property="og:image" content={`${baseUrl}/project-preview/omnigraph/corphurusato.jpg`} />
        <meta property="og:url" content={`${baseUrl}/lp/corpfurusato`} />
        <meta property="og:site_name" content="アニメファンド" />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <link rel="canonical" href={`${baseUrl}/lp/corpfurusato`} />
        <meta name="robots" content={robotsValue} />
      </Head>
      <LibraryContextProvider>
        <Header positionFixed={false} hideFlowingComment />
        <Background />
        <Main>
          <KeyVisual />
          <AboutCorpHurusato />
          <AboutCorpAnimeHurusato />
          <SimulatorSection />
          <DeductionFlow />
          <Faq />
        </Main>
        <Footer />
      </LibraryContextProvider>
    </>
  );
};
export default withFrontAuth(CorpHurusato);
